"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = '#fff';
exports.black = '#000';
exports.red = '#ff0000';
exports.green = '#00ff00';
exports.blue = '#0000ff';
exports.donkey = '#eaeaea';
exports.citroenC3 = '#c3c3c3';
exports.foreignCrimson = '#c91f37';
exports.redOrange = '#dc3023';
exports.cochinealRed = '#9d2933';
exports.monza = '#cf000f';
exports.brewedMustardBrown = '#e68364';
exports.pomegranate = '#f22613';
exports.scarlet = '#cf3a24';
exports.pureCrimson = '#c3272b';
exports.trueRed = '#8f1d21';
exports.chestnutRose = '#d24d57';
exports.oneKinDye = '#f08f90';
exports.peachColored = '#f47983';
exports.redPlumColored = '#db5a6b';
exports.mediumCrimson = '#c93756';
exports.cherryBlossomColor = '#fcc9b9';
exports.washedOutCrimson = '#ffb3a7';
exports.radicalRed = '#f62459';
exports.ibisWingColor = '#f58f84';
exports.wisteriaPurple = '#875f9a';
exports.bellflowerColor = '#5d3f6a';
exports.wisteriaColor = '#89729e';
exports.irisColor = '#763568';
exports.tatarianAsterColor = '#8d608c';
exports.thinColor = '#a87ca0';
exports.violetColor = '#5b3256';
exports.mediumPurple = '#bf55ec';
exports.studio = '#8e44ad';
exports.wisteria = '#9b59b6';
exports.lightWisteria = '#be90d4';
exports.skyColor = '#4d8fac';
exports.ultramarineColor = '#5d8cae';
exports.pictonBlue = '#22a7f0';
exports.dodgerBlue = '#19b5fe';
exports.pictonBlue2 = '#59abe3';
exports.lightBlueColor = '#48929b';
exports.thousandHerb = '#317589';
exports.jordyBlue = '#89c4f4';
exports.steelBlue = '#4b77be';
exports.lapisLazuliColor = '#1f4788';
exports.navyBlueColor = '#003171';
exports.hanada = '#044f67';
exports.indigoColor = '#264348';
exports.siskinSproutYellow = '#7a942e';
exports.youngGreenOnion = '#8db255';
exports.freshOnion = '#5b8930';
exports.youngBambooColor = '#6b9362';
exports.patina = '#407a52';
exports.greenBamboo = '#006442';
exports.gossip = '#87d37c';
exports.eucalyptus = '#26a65b';
exports.jungleGreen = '#26c281';
exports.observatory = '#049372';
exports.jungleGreen2 = '#2abb9b';
exports.mountainMeadow = '#16a085';
exports.turquoise = '#36d7b7';
exports.freeSpeechAquamarine = '#03a678';
exports.oceanGreen = '#4daf7c';
exports.patriniaFlowers = '#d9b611';
exports.amurCorkTree = '#f3c13a';
exports.ripeLemon = '#f7ca18';
exports.japaneseTriandraGrass = '#e2b13c';
exports.rapeseedOilColored = '#a17917';
exports.creamCan = '#f5d76e';
exports.saffron = '#f4d03f';
exports.brightGoldenYellow = '#ffa400';
exports.sumacDyed = '#e08a1e';
exports.gamboge = '#ffb61e';
exports.cornColored = '#faa945';
exports.eggColored = '#ffa631';
exports.floralLeafColored = '#ffb94e';
exports.goldenFallenLeaves = '#e29c45';
exports.ecstasy = '#f9690e';
exports.amber = '#ca6924';
exports.lightningYellow = '#f5ab35';
exports.silver = '#bfbfbf';
exports.cararra = '#f2f1ef';
exports.silverSand = '#bdc3c7';
exports.porcelain = '#ecf0f1';
exports.pumice = '#d2d7d3';
exports.harborRat = '#757d75';
exports.gallery = '#eeeeee';
exports.edward = '#abb7b7';
exports.lynch = '#6c7a89';
exports.cascade = '#95a5a6';